import { IAseguradora } from '../interfaces/aseguradora';
import { IContacto } from '../interfaces/contacto';
import { ICitaDetalle } from '../interfaces/citaDetalle';

export class CitaDetalle implements ICitaDetalle {
    IdCita: number;
    Fecha: Date;
    Descripcion: string;
    Comentario: string;
    IdSucursal: number;
    Aseguradora: IAseguradora;
    Contacto: IContacto;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/citaDetalle.ts